import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { rpc } from '@/api/rpc'
import { Select } from '@/components/form/select'
import { Card } from '@/components/ui/card'
import { formatWhen } from '@/lib/format'

type Entry = {
  id: number
  at: string
  action: string
  table_name: string
  row_id: string | null
  before: unknown
  after: unknown
  actor: string | null
}

const TABLES = [
  'reluxes',
  'projects',
  'profiles',
  'feature_flags',
  'settings',
  'products',
  'files',
  'design_options',
  'lux_reference',
  'auth',
]

export const Route = createFileRoute('/_app/admin/audit')({ component: Audit })

/** Every create, update, delete, reorder, flag change, import and login, with before/after. */
function Audit() {
  const [table, setTable] = useState('')
  const { data, error } = useQuery({
    queryKey: ['audit', table],
    queryFn: () => rpc<Entry[]>('admin_audit_log', { max_rows: 200, table_filter: table || null }),
  })
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-3xl uppercase">Audit log</h1>
      <Select
        aria-label="Table"
        value={table}
        onChange={(e) => setTable(e.target.value)}
        options={TABLES}
        placeholder="Everything"
        className="w-60"
      />
      {error && <p className="font-semibold text-danger">{error.message}</p>}
      <ul className="flex flex-col gap-2">
        {data?.map((e) => (
          <li key={e.id}>
            <Card className="p-3">
              <details>
                <summary className="cursor-pointer">
                  <span className="font-semibold">{e.actor ?? 'System'}</span> {e.action}{' '}
                  {e.table_name} <span className="text-sm text-fg-muted">{formatWhen(e.at)}</span>
                </summary>
                <pre className="relative mt-2 overflow-x-auto text-xs whitespace-pre-wrap">
                  {JSON.stringify({ before: e.before, after: e.after }, null, 2)}
                </pre>
              </details>
            </Card>
          </li>
        ))}
      </ul>
    </div>
  )
}
